import React from "react";
import { connect } from "react-redux";
import { CreatorContainerStyled } from "./styled";
// import { adminService } from "apiService";
// import { toast } from "react-toastify";
import { setReduxUserAuth } from "actions";
import { AgencyFormCreator } from "forms/AdminFormSystem";

class CreatorContainer extends React.Component {
  state = {};

  componentDidMount() {

  }

  render() {
    const { initialValues } = this.state;
    const { agencyID } = this.props;

    return (
      <CreatorContainerStyled>
        <AgencyFormCreator
          agencyID={agencyID}
          initialValues={initialValues}
          handleRemoveGenre={this.handleRemoveGenre}
          handdleSave={this.handdleSave}
        />
      </CreatorContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authRedux: state.auth,
  reduxForm: state.form.AgencyFormCreator,
});

const mapDispatchToProps = (dispatch) => ({
  setReduxUserAuth: (data) => dispatch(setReduxUserAuth(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreatorContainer);
